const listeners = {};
 
export const subscribe = (eventName, listener) => {
    if (!listeners[eventName]) {
        listeners[eventName] = [];
    }
    listeners[eventName].push(listener);
    const unsubscribe = () => {
        listeners[eventName] = listeners[eventName].filter(savedListener => savedListener !== listener);
    }
    return unsubscribe;
}
 
export const emit = (eventName, data) => {
    if (listeners[eventName]) {
        listeners[eventName].forEach((listener) => {
          listener(data);
        });
    }
}